import React from "react";
import { Phone, Mail, MapPin, Clock, AlertCircle } from "lucide-react";
import { Reveal, SectionHeading } from "../components/common";
import EnquiryForm from "../components/EnquiryForm";
import { business, hours } from "../data/mock";

export default function Contact() {
  return (
    <div className="overflow-hidden">
      <section className="relative pt-32 pb-16 md:pt-40">
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-sky-50 to-white" />
        <div className="max-w-7xl mx-auto px-5 text-center">
          <Reveal>
            <span className="inline-block text-sm font-semibold tracking-wider uppercase text-sky-600 mb-3">Get in Touch</span>
            <h1 className="font-heading text-4xl md:text-6xl font-extrabold text-slate-900">Ready when you are.</h1>
            <p className="mt-4 text-lg text-slate-600 max-w-xl mx-auto">Call the mobile, drop an email, or leave a quick message. Fred replies personally — usually the same day.</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-5 grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-4">
            <Reveal>
              <div className="grid sm:grid-cols-2 gap-4">
                <a href={business.phoneHref} className="rounded-2xl border border-slate-200 bg-white p-6 hover:border-sky-300 hover:shadow-lg transition-all">
                  <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-sky-50 text-sky-600"><Phone size={22} /></span>
                  <div className="mt-4 font-heading font-bold text-slate-900">Call mobile</div>
                  <div className="text-slate-600 text-sm">{business.phone}</div>
                </a>
                <a href={business.emailHref} className="rounded-2xl border border-slate-200 bg-white p-6 hover:border-sky-300 hover:shadow-lg transition-all">
                  <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-sky-50 text-sky-600"><Mail size={22} /></span>
                  <div className="mt-4 font-heading font-bold text-slate-900">Email</div>
                  <div className="text-slate-600 text-sm">{business.email}</div>
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.05}>
              <div className="rounded-2xl border border-slate-200 bg-white p-6">
                <div className="flex items-center gap-2 font-heading font-bold text-slate-900"><Clock size={18} className="text-sky-500" /> Opening Hours</div>
                <ul className="mt-4 space-y-1.5 text-sm">
                  {hours.map((h) => (
                    <li key={h.day} className="flex justify-between border-b border-slate-100 pb-1.5 last:border-0">
                      <span className="text-slate-500">{h.day}</span>
                      <span className={h.open ? "text-slate-800 font-medium" : "text-slate-400"}>{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="rounded-2xl border border-slate-200 bg-white p-6">
                <div className="flex items-start gap-2"><MapPin size={18} className="text-sky-500 mt-0.5" /><div><div className="font-heading font-bold text-slate-900">Service area</div><div className="text-slate-600 text-sm">{business.area}</div><div className="text-slate-500 text-sm mt-1">{business.address}</div></div></div>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="rounded-2xl bg-orange-50 border border-orange-100 p-5 flex items-start gap-3">
                <AlertCircle size={20} className="text-orange-500 mt-0.5 shrink-0" />
                <p className="text-sm text-orange-700">Please call the mobile only — the landline is unplugged. Leave a message if I'm busy and I'll get right back to you.</p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <EnquiryForm type="general" title="Send Fred a quick message" subtitle="He'll get back to you as soon as he's off the bench." />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
